import React, { Component }        from 'react';
import moment                      from 'moment';
import { Redirect,Link }          from 'react-router-dom';
import { connect }                 from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form';
import renderField                 from '../../../../container/renderField';
import renderFieldSelec            from '../../../../container/renderFieldSelect';
import renderMultiselect           from '../../../../container/renderMultiSelect';
import renderDatePicker            from '../../../../container/renderDatePicker';
import validate                    from '../../../../service/validade_missoes';
import { SetDuplicarAtividade,
            GetEditarAtividades,
            GetAtividadesLista }    from '../../../../actions/atividadesAction';
import { SetError }                from '../../../../actions/notificacaoAction';
import { getDisciplinaPerfil }     from '../../../../actions/batalhaAction';
import { ActionModal}               from '../../../../actions/scopoAction';


class Desafios_Cadastro extends Component {

    constructor(props){
        super(props);
        this.state = {
                       redirect        : false,
                       redirectQuestao : false,
                       data            : moment(),
                       habilitar       : true,
                       use_id          : this.props.session.id,
                       textButton      : 'Duplicar',
                       titulo          : "Duplicar desafio",
                       form            : true,
                       formAdicionar   : false
                      }
    }

    componentWillMount() {

        this.props.getDisciplinaPerfil(this.props.session.id, this.props.session.perfil,null).then((response) => {
            if(!response.payload.data.length){
                alert("Você não está vinculado a nenhuma Unidade Curricular até o momento.")
                this.setState({redirect:true})   
            }
        }).catch((error)=>{
            this.props.SetError(500);
        });


        
      this.props.GetEditarAtividades(this.props.match.params.id).then((response)=>{
        const dados = response.data.atividade;
        this.props.initialize({
                                  ati_tipo      : dados.ati_tipo,
                                  ati_titulo    : `${dados.ati_titulo} (2)`,
                                  ati_id        : dados.ati_id,
                                  ati_qtd_tempo : dados.ati_qtd_tempo,
                              });
        this.setState({
                            data       : dados.ati_data_inicio,
                            dataFim    : dados.ati_data_fim,
                            ati_id     : dados.ati_id
                            });

       }).catch((error)=>{
         this.props.SetError(500);
       });        

    }

    handleSubmit(e){
        
         var acaoForm = { usu_id             : this.props.session.id,
                          ati_data_inicio    : moment(this.state.data).format('YYYY-MM-DD'),
                          ati_data_fim       : moment(this.state.dataFim).format('YYYY-MM-DD'),
                          ati_titulo         : e.ati_titulo,
                          disciplina_turma   : e.disciplinas.map((elem,i)=>{return elem.id;}),
                          ati_tipo           : e.ati_tipo,
                          ati_qtd_tentativas : parseInt(e.ati_qtd_ten),
                          ati_id             : this.state.ati_id
                         }

       this.setState({textButton:'Enviando...'});

       this.props.SetDuplicarAtividade(acaoForm).then((response)=>{  
             alert('Ação realizada com sucesso!'); 
             this.setState({redirect:true});           
        }).catch((error)=>{
            this.props.SetError(500);
        });
    }

    dataInicioChange(e){
      this.setState({data:moment(e, 'YYYY-MM-DD', true),habilitar:false})
    }
    
    dataFimChange(e){
      this.setState({dataFim:moment(e, 'YYYY-MM-DD', true)})
    }

    render() {
        
        if (this.state.redirect) {
          return (<Redirect to={this.props.menu.desafios.home}/>);
        }

        const {handleSubmit}  = this.props;
        const listaQtdTen     = [1, 2, 3];
        const listQdtTen      = listaQtdTen.map((ten, ar)  => <option key={ar} value={ten}>{ten}</option>);
        const listaTipoMissao = [
                                {
                                    tipo: this.props.menu.desafios.jogo.jogo2,
                                    value: this.props.menu.desafios.jogo.tipo2
                                },
                                {
                                    tipo: this.props.menu.desafios.jogo.jogo3,
                                    value: this.props.menu.desafios.jogo.tipo3
                                },
                                {
                                    tipo: this.props.menu.desafios.jogo.jogo1,
                                    value: this.props.menu.desafios.jogo.tipo1
                                }
                                ];
        const listTipoMissao  = listaTipoMissao.map((elem, i)  => <option key={i} value={elem.value}>{elem.tipo}</option>);
        const disciplinas     = this.props.disciplinas.map((elem,i)=>{ return {disciplinas:elem.tur_nome+' - '+elem.dis_nome+' - '+elem.cur_nome,id:elem.dis_pro_cod_disciplina + '#' + elem.tur_id}});
       
        const formMissao   = <div className="panel panel-default">
                                    <div className="panel-heading"><b>Duplicar desafio</b></div>
                                        <div className="panel-body">     
                                                    <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                                                            <Field name="ati_titulo" label="Título*" component={renderField} type="text" placeholder="Título" />
                                                            <div className="row">
                                                            <div className="col-md-6">
                                                                <Field name="ati_tipo" label="Selecione o tipo de desafio*" component={renderFieldSelec} option={listTipoMissao}/> 
                                                            </div>  
                                                            <div className="col-md-6">
                                                            <Field name="ati_qtd_ten" label="Quantidade de Tentativa*" component={renderFieldSelec} option={listQdtTen}/>
                                                            </div>   
                                                            </div>
                                                            <div className="row">
                                                            <div className="col-md-6">
                                                                <Field  label="Data Ínicio*" minData={moment()} component={renderDatePicker} name="ati_data_ini" onChange={this.dataInicioChange.bind(this)}/>
                                                            </div>  
                                                            <div className="col-md-6">
                                                                <Field label="Data Fim*" minData={this.state.data} component={renderDatePicker} habilitar={this.state.habilitar} name="ati_data_fim" onChange={this.dataFimChange.bind(this)}/>
                                                            </div>   
                                                            </div>
                                                            <Field name="disciplinas" label="Unidade Curricular/Turma*" value='id' textField='disciplinas' data={disciplinas} component={renderMultiselect}/>
                                                            <Link  to={this.props.menu.desafios.home} className="btn btn-sm btn-primary pull-left">Voltar</Link>
                                                            <button type="submit" className="btn btn-primary btn-sm pull-right">{this.state.textButton}</button>
                                                        </form>
                                            </div>
                                     </div>

        return (
            <div>
                   
                    {formMissao}
              

            </div>
        );
    }
}
const afterSubmit = (result, dispatch) => dispatch(reset('missoes_form'));

function mapStateToProps(state){

    return {
             session     : state.auth.session,
             disciplinas : state.batalhaReducer.allDisciplina,
             menu        : state.configReducer.menu
            };
  }

export default reduxForm({
  form                     : 'missoes_form',
  destroyOnUnmount         : true,
  forceUnregisterOnUnmount : true,
  onSubmitSuccess          : afterSubmit,
  validate
})(connect(mapStateToProps, {getDisciplinaPerfil,
                             SetDuplicarAtividade,
                             GetEditarAtividades,
                             GetAtividadesLista,
                             ActionModal,
                             SetError})(Desafios_Cadastro));




// WEBPACK FOOTER //
// ./src/components/professor/desafios/form/desafios_duplicar.js